const SITE_URL = "https://pellonmorel.com";
const BUSINESS_NAME = "Pellon Morel Solutions";
const PHONE_DISPLAY = "(757) 650-3192";
const PHONE_TEL = "+17576503192";
const EMAIL = "info@pellonmorel.com";
const LOGO_URL = `${SITE_URL}/android-chrome-512x512.png`;

const CITIES = [
  { slug: "plumber-norfolk-va", name: "Norfolk", wiki: "https://en.wikipedia.org/wiki/Norfolk,_Virginia" },
  { slug: "plumber-virginia-beach-va", name: "Virginia Beach", wiki: "https://en.wikipedia.org/wiki/Virginia_Beach,_Virginia" },
  { slug: "plumber-chesapeake-va", name: "Chesapeake", wiki: "https://en.wikipedia.org/wiki/Chesapeake,_Virginia" },
  { slug: "plumber-portsmouth-va", name: "Portsmouth", wiki: "https://en.wikipedia.org/wiki/Portsmouth,_Virginia" },
  { slug: "plumber-suffolk-va", name: "Suffolk", wiki: "https://en.wikipedia.org/wiki/Suffolk,_Virginia" },
  { slug: "plumber-hampton-va", name: "Hampton", wiki: "https://en.wikipedia.org/wiki/Hampton,_Virginia" },
  { slug: "plumber-newport-news-va", name: "Newport News", wiki: "https://en.wikipedia.org/wiki/Newport_News,_Virginia" },
];

const SERVICE_LINKS = [
  { slug: "drain-cleaning", en: "Drain Cleaning", es: "Destapado de Drenajes" },
  { slug: "water-heater-repair", en: "Water Heater Repair & Installation", es: "Reparación e Instalación de Water Heaters" },
  { slug: "tankless-water-heaters", en: "Tankless Water Heaters", es: "Calentadores Tankless" },
  { slug: "leak-repair", en: "Leak Detection & Repair", es: "Detección y Reparación de Fugas" },
  { slug: "toilet-repair", en: "Toilet Repair & Replacement", es: "Reparación y Reemplazo de Inodoros" },
  { slug: "faucet-shower-repair", en: "Faucet & Shower Valve Repair", es: "Reparación de Grifos y Válvulas de Ducha" },
  { slug: "repiping", en: "PEX Repiping", es: "Repiping con PEX" },
  { slug: "sewer-drain-services", en: "Sewer & Drain Services", es: "Servicios de Alcantarillado y Drenajes" },
];

// Full list of services shown on city pages; `slug` links to a service page when one exists
const CITY_SERVICES = [
  { en: "Plumbing repairs", es: "Reparaciones de plomería" },
  { en: "Drain cleaning", es: "Destapado de drenajes", slug: "drain-cleaning" },
  { en: "Leak detection and repair", es: "Detección y reparación de fugas", slug: "leak-repair" },
  { en: "Water heater repair and installation", es: "Reparación e instalación de water heaters", slug: "water-heater-repair" },
  { en: "Tankless water heaters", es: "Calentadores tankless", slug: "tankless-water-heaters" },
  { en: "Toilet repair and replacement", es: "Reparación y reemplazo de inodoros", slug: "toilet-repair" },
  { en: "Faucet and shower valve repair", es: "Reparación de grifos y válvulas de ducha", slug: "faucet-shower-repair" },
  { en: "Garbage disposal installation", es: "Instalación de trituradores de basura" },
  { en: "Kitchen plumbing", es: "Plomería de cocina" },
  { en: "Bathroom plumbing", es: "Plomería de baño" },
  { en: "PEX repiping", es: "Repiping con PEX", slug: "repiping" },
  { en: "Water line repairs", es: "Reparación de líneas de agua" },
  { en: "Sewer and drain troubleshooting", es: "Diagnóstico de alcantarillado y drenajes", slug: "sewer-drain-services" },
  { en: "Plumbing camera inspections", es: "Inspecciones de plomería con cámara" },
];

const CTA = {
  en: { estimate: "Request a Free Estimate", call: "Call Now", schedule: "Schedule Service" },
  es: { estimate: "Solicitar Estimado Gratis", call: "Llamar Ahora", schedule: "Agendar Servicio" },
};

module.exports = { SITE_URL, BUSINESS_NAME, PHONE_DISPLAY, PHONE_TEL, EMAIL, LOGO_URL, CITIES, SERVICE_LINKS, CITY_SERVICES, CTA };
